import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin && admin.email) navigate("/admin");
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.19, 1, 0.22, 1] }}
        className="w-full max-w-md"
        data-testid="admin-login-page"
      >
        <p className="font-serif text-5xl text-aak-fg text-center mb-2">AAK<span className="text-aak-primary">.</span></p>
        <p className="text-xs uppercase tracking-[0.3em] text-aak-primary text-center mb-12">Atelier Admin</p>

        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] text-aak-mutedfg">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border-b border-aak-border py-3 text-lg text-aak-fg outline-none focus:border-aak-primary transition-colors"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] text-aak-mutedfg">Password</label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border-b border-aak-border py-3 text-lg text-aak-fg outline-none focus:border-aak-primary transition-colors"
            />
          </div>
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-aak-fg text-aak-bg py-4 text-xs uppercase tracking-[0.25em] hover:bg-aak-primary transition-colors duration-500 flex items-center justify-center disabled:opacity-60"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enter Atelier"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
